module.exports = ".table-container{\r\n    width: 100%;\r\n    overflow-x: auto;\r\n}"